module.exports = __webpack_public_path__ + "static/img/Tom_Jonas_desktop.3b9c14d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom_Jonas_desktop.jpg
// module id = rGu8
// module chunks = 0